import { useBlogStore } from "./blogStore";
import { useCountryStore } from "./countryStore";
import { useDashboardStore } from "./dashboardStore";
import { useMoneyPageStore } from "./moneyPageStore";
import { useOrderStore } from "./orderStore";
import { useOthersStore } from "./othersStore";
import { usePromoCodeStore } from "./promoCodeStore";
import { useSupportStore } from "./supportStore";
import { useUniversityStore } from "./universityStore";
import { useUserStore } from "./userStore";

export const resetAllStores = () => {
  const stores = [
    useBlogStore,
    useCountryStore,
    useDashboardStore,
    useMoneyPageStore,
    useOrderStore,
    useOthersStore,
    usePromoCodeStore,
    useSupportStore,
    useUniversityStore,
    useUserStore,
  ];

  stores.forEach((store) => {
    const reset = store.getState().reset;
    if (reset) reset();
  });
};
